import { baseUrlApis, FROM_TYPE } from '@/api';
import { apiMap } from 'Pages/eSignCNWebContainer/api';
import { MessageUtil } from 'Api/utils/Message.util';

function initPostMessageTool(pcDomain) {
    const callback = async (method, data) => {
        if(apiMap[method]) {
            const stateHook = (state) => {
                state && this.setState(state)
            }
            return apiMap[method]({ ...data, stateHook })
        } else {
            console.log('not exist method', method);
        }
    }
    const windowMessageUtil = new MessageUtil();
    windowMessageUtil.init(callback, FROM_TYPE.WIN_PHANTOM_ESIGNCN_PLUGIN, pcDomain)
    return { msgTool: windowMessageUtil, childWindowDomain: pcDomain };
    // windowMessageUtil.handleMessage(method, data)
    //     .then(ret => {
    //         console.log('online has receive response', ret)
    //     })
}

export function initESignCNMsgTool () {
    return baseUrlApis.loadUrlConfig().then(config => {
        let pcDomain = window.location.hostname === 'localhost' ? 'http://localhost:3001' : config.newEsignCNpc;
        if (localStorage.getItem('DevelopAddress')) {
            pcDomain = localStorage.getItem('DevelopAddress');
        }
        return initPostMessageTool(pcDomain)
    })
}